document.querySelectorAll('.product-card-swiper').forEach(el => {
  /*
   * Prevent the browser's native link/image drag from swallowing mouse events.
   * Without this, mousedown on an <img> inside an <a> fires "dragstart", which
   * captures all subsequent mousemove events before Swiper can see them.
   */
  el.addEventListener('dragstart', e => e.preventDefault());

  /*
   * Nav buttons sit outside the <a> tag (siblings inside the media container)
   * so clicking them never triggers product page navigation.
   */
  const mediaContainer = el.closest('a')?.parentElement;
  const prevBtn = mediaContainer?.querySelector('.product-card-nav-prev');
  const nextBtn = mediaContainer?.querySelector('.product-card-nav-next');

  const swiper = new Swiper(el, {
    loop: true,
    grabCursor: true,
    navigation: prevBtn ? {
      prevEl: prevBtn,
      nextEl: nextBtn,
    } : false,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      clickable: true,
    },
  });

  /*
   * Trackpad horizontal swipe support (macOS two-finger swipe).
   * Mac trackpads fire wheel events with deltaX rather than touch events,
   * so simulateTouch doesn't help. We accumulate deltaX and fire slideNext /
   * slidePrev once the gesture crosses a threshold, then reset.
   * We only call preventDefault() for horizontal scrolls so vertical page
   * scrolling over a card is completely unaffected.
   */
  let accDeltaX = 0;
  let wheelTimer;
  el.addEventListener('wheel', e => {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // vertical — let it pass
    e.preventDefault();
    accDeltaX += e.deltaX;
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { accDeltaX = 0; }, 500);
    if (accDeltaX > 50) {
      accDeltaX = 0;
      swiper.slideNext();
    } else if (accDeltaX < -50) {
      accDeltaX = 0;
      swiper.slidePrev();
    }
  }, { passive: false });
});
